var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76 84V76C76 71.7565 74.3143 67.6869 71.3137 64.6863C68.3131 61.6857 64.2435 60 60 60H36C31.7565 60 27.6869 61.6857 24.6863 64.6863C21.6857 67.6869 20 71.7565 20 76V84",
    stroke: "black",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 44C56.8366 44 64 36.8366 64 28C64 19.1634 56.8366 12 48 12C39.1634 12 32 19.1634 32 28C32 36.8366 39.1634 44 48 44Z",
    stroke: "black",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgUser;